import activity from './icons/activity.svg';
import archive from './icons/archive.svg';
import arrow2down from './icons/arrow-2-down.svg';
import arrow2left from './icons/arrow-2-left.svg';
import arrow2right from './icons/arrow-2-right.svg';
import arrow2up from './icons/arrow-2-up.svg';
import arrowdown from './icons/arrow-down.svg';
import arrowleft from './icons/arrow-left.svg';
import arrowright from './icons/arrow-right.svg';
import arrowup from './icons/arrow-up.svg';
import ban from './icons/ban.svg';
import barcode from './icons/barcode.svg';
import basketsolid from './icons/basket-solid.svg';
import bolt from './icons/bolt.svg';
import boxshipping from './icons/box-shipping.svg';
import briefcase from './icons/briefcase.svg';
import building from './icons/building.svg';
import calculator from './icons/calculator.svg';
import calendar from './icons/calendar.svg';
import caret2down from './icons/caret-2-down.svg';
import caret2left from './icons/caret-2-left.svg';
import caret2right from './icons/caret-2-right.svg';
import caret2up from './icons/caret-2-up.svg';
import caretdown from './icons/caret-down.svg';
import caretleft from './icons/caret-left.svg';
import caretright from './icons/caret-right.svg';
import caretup from './icons/caret-up.svg';
import caretupdown from './icons/caret-updown.svg';
import cartsolid from './icons/cart-solid.svg';
import cartstroke from './icons/cart-stroke.svg';
import chartsolid from './icons/chart-solid.svg';
import checkmark from './icons/checkmark.svg';
import checkmarkcircle from './icons/checkmark-circle.svg';
import chevrondown from './icons/chevron-down.svg';
import chevronleft from './icons/chevron-left.svg';
import chevronright from './icons/chevron-right.svg';
import chevronup from './icons/chevron-up.svg';
import clock from './icons/clock.svg';
import cloud from './icons/cloud.svg';
import combine from './icons/combine.svg';
import comboshipment from './icons/combo-shipment.svg';
import copy from './icons/copy.svg';
import copysolid from './icons/copy-solid.svg';
import customs from './icons/customs.svg';
import document from './icons/document.svg';
import download from './icons/download.svg';
import exclamationcirclesolid from './icons/exclamation-circle-solid.svg';
import exclamationtrianglesolid from './icons/exclamation-triangle-solid.svg';
import externallink from './icons/external-link.svg';
import filterssolid1 from './icons/filters-solid-1.svg';
import filterssolid2 from './icons/filters-solid-2.svg';
import filtersstroke1 from './icons/filters-stroke-1.svg';
import folderopen from './icons/folder-open.svg';
import fulfillmentrequested from './icons/fulfillment-requested.svg';
import gaugesolid from './icons/gauge-solid.svg';
import gear from './icons/gear.svg';
import ghostbusters from './icons/ghostbusters.svg';
import gift from './icons/gift.svg';
import globe from './icons/globe.svg';
import gridcolumns from './icons/grid-columns.svg';
import gripper from './icons/gripper.svg';
import group from './icons/group.svg';
import heart from './icons/heart.svg';
import help from './icons/help.svg';
import hidedrawer from './icons/hide-drawer.svg';
import house from './icons/house.svg';
import informationcirclesolid from './icons/information-circle-solid.svg';
import keysolid from './icons/key-solid.svg';
import labelcreated from './icons/label-created.svg';
import labellight from './icons/label-light.svg';
import labelprinted from './icons/label-printed.svg';
import languages from './icons/languages.svg';
import lightningbolt from './icons/lightning-bolt.svg';
import locked from './icons/locked.svg';
import mailsolid from './icons/mail-solid.svg';
import mailstroke from './icons/mail-stroke.svg';
import maplocationpin from './icons/map-location-pin.svg';
import mapsolid from './icons/map-solid.svg';
import marketplacenotified from './icons/marketplace-notified.svg';
import megaphone from './icons/megaphone.svg';
import menuhamburger from './icons/menu-hamburger.svg';
import minus from './icons/minus.svg';
import morehorizontal from './icons/more-horizontal.svg';
import morevertical from './icons/more-vertical.svg';
import next from './icons/next.svg';
import noimage from './icons/no-image.svg';
import notefromcustomer from './icons/note-from-customer.svg';
import noteinternal from './icons/note-internal.svg';
import notesfilled from './icons/notes-filled.svg';
import notesfromfilled from './icons/notes-from-filled.svg';
import notesfromoutlined from './icons/notes-from-outlined.svg';
import notesoutlined from './icons/notes-outlined.svg';
import notestofilled from './icons/notes-to-filled.svg';
import notestooutlined from './icons/notes-to-outlined.svg';
import notetocustomer from './icons/note-to-customer.svg';
import oldcalculator from './icons/old-calculator.svg';
import packingslipprinted from './icons/packing-slip-printed.svg';
import paintbrush from './icons/paintbrush.svg';
import pencil from './icons/pencil.svg';
import person from './icons/person.svg';
import phone from './icons/phone.svg';
import plane from './icons/plane.svg';
import plus from './icons/plus.svg';
import previous from './icons/previous.svg';
import printer from './icons/printer.svg';
import profilemenu from './icons/profile-menu.svg';
import profilesolid from './icons/profile-solid.svg';
import profilestroke from './icons/profile-stroke.svg';
import questioncirclesolid from './icons/question-circle-solid.svg';
import refresh from './icons/refresh.svg';
import repeat from './icons/repeat.svg';
import reply from './icons/reply.svg';
import returnarrow from './icons/return-arrow.svg';
import scale from './icons/scale.svg';
import search from './icons/search.svg';
import settings from './icons/settings.svg';
import settingsgear from './icons/settings-gear.svg';
import showdrawer from './icons/show-drawer.svg';
import sort from './icons/sort.svg';
import spinner from './icons/spinner.svg';
import spinner7of8 from './icons/spinner-7-of-8.svg';
import star from './icons/star.svg';
import tagsolid from './icons/tag-solid.svg';
import trashsolid from './icons/trash-solid.svg';
import trashstroke from './icons/trash-stroke.svg';
import truck from './icons/truck.svg';
import truckfast from './icons/truck-fast.svg';
import unlocked from './icons/unlocked.svg';
import upload from './icons/upload.svg';
import weight from './icons/weight.svg';
import xmark from './icons/xmark.svg';
import xmarkcircle from './icons/xmark-circle.svg';

export default {
  activity,
  archive,
  'arrow-2-down': arrow2down,
  'arrow-2-left': arrow2left,
  'arrow-2-right': arrow2right,
  'arrow-2-up': arrow2up,
  'arrow-down': arrowdown,
  'arrow-left': arrowleft,
  'arrow-right': arrowright,
  'arrow-up': arrowup,
  ban,
  barcode,
  'basket-solid': basketsolid,
  bolt,
  'box-shipping': boxshipping,
  briefcase,
  building,
  calculator,
  calendar,
  'caret-2-down': caret2down,
  'caret-2-left': caret2left,
  'caret-2-right': caret2right,
  'caret-2-up': caret2up,
  'caret-down': caretdown,
  'caret-left': caretleft,
  'caret-right': caretright,
  'caret-up': caretup,
  'caret-updown': caretupdown,
  'cart-solid': cartsolid,
  'cart-stroke': cartstroke,
  'chart-solid': chartsolid,
  checkmark,
  'checkmark-circle': checkmarkcircle,
  'chevron-down': chevrondown,
  'chevron-left': chevronleft,
  'chevron-right': chevronright,
  'chevron-up': chevronup,
  clock,
  cloud,
  combine,
  'combo-shipment': comboshipment,
  copy,
  'copy-solid': copysolid,
  customs,
  document,
  download,
  'exclamation-circle-solid': exclamationcirclesolid,
  'exclamation-triangle-solid': exclamationtrianglesolid,
  'external-link': externallink,
  'filters-solid-1': filterssolid1,
  'filters-solid-2': filterssolid2,
  'filters-stroke-1': filtersstroke1,
  'folder-open': folderopen,
  'fulfillment-requested': fulfillmentrequested,
  'gauge-solid': gaugesolid,
  gear,
  ghostbusters,
  gift,
  globe,
  'grid-columns': gridcolumns,
  gripper,
  group,
  heart,
  help,
  'hide-drawer': hidedrawer,
  house,
  'information-circle-solid': informationcirclesolid,
  'key-solid': keysolid,
  'label-created': labelcreated,
  'label-light': labellight,
  'label-printed': labelprinted,
  languages,
  'lightning-bolt': lightningbolt,
  locked,
  'mail-solid': mailsolid,
  'mail-stroke': mailstroke,
  'map-location-pin': maplocationpin,
  'map-solid': mapsolid,
  'marketplace-notified': marketplacenotified,
  megaphone,
  'menu-hamburger': menuhamburger,
  minus,
  'more-horizontal': morehorizontal,
  'more-vertical': morevertical,
  next,
  'no-image': noimage,
  'note-from-customer': notefromcustomer,
  'note-internal': noteinternal,
  'notes-filled': notesfilled,
  'notes-from-filled': notesfromfilled,
  'notes-from-outlined': notesfromoutlined,
  'notes-outlined': notesoutlined,
  'notes-to-filled': notestofilled,
  'notes-to-outlined': notestooutlined,
  'note-to-customer': notetocustomer,
  'old-calculator': oldcalculator,
  'packing-slip-printed': packingslipprinted,
  paintbrush,
  pencil,
  person,
  phone,
  plane,
  plus,
  previous,
  printer,
  'profile-menu': profilemenu,
  'profile-solid': profilesolid,
  'profile-stroke': profilestroke,
  'question-circle-solid': questioncirclesolid,
  refresh,
  repeat,
  reply,
  'return-arrow': returnarrow,
  scale,
  search,
  settings,
  'settings-gear': settingsgear,
  'show-drawer': showdrawer,
  sort,
  spinner,
  'spinner-7-of-8': spinner7of8,
  star,
  'tag-solid': tagsolid,
  'trash-solid': trashsolid,
  'trash-stroke': trashstroke,
  truck,
  'truck-fast': truckfast,
  unlocked,
  upload,
  weight,
  xmark,
  'xmark-circle': xmarkcircle,
};
